const CLOUD_NAME = 'drtpdruod';
const UPLOAD_PRESET = 'ranger_files';

export const uploadFilesToCloudinary = async (files: File[]): Promise<string[]> => {
  const uploadedUrls: string[] = [];

  for (const file of files) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);

    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Unable to upload file to Cloudinary.');
    }

    const data = (await response.json()) as { secure_url?: string };
    if (data.secure_url) {
      uploadedUrls.push(data.secure_url);
    }
  }

  return uploadedUrls;
};
